// Experiment 3 : page with a URL parameter (/user/:id)
import React from "react";
import { useParams } from "react-router-dom";

export default function UserPage() {
  let { id } = useParams();
  return (
    <div className="container">
      <h1>Hello there user {id}</h1>
      <p>This is your User Profile page</p>
    </div>
  );
}
